import { TokenProvider } from '~/hooks/auth/useMsalTokenProvider';
import { BackendClient } from './backend-client';
import { APIType } from './types';

export class ContouringClient extends BackendClient {
    constructor(
        baseURL: string,
        tokenProvider: TokenProvider,
        sessionID: string
    ) {
        super(baseURL, tokenProvider, sessionID, APIType.CONTOURING);
    }
}
